
export enum Brand {
    Savanta = 1,
    Clariti = 2
}
